module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9r2r5n-9264f1ac31419c31d71082c06ca90acf.svg";